export default __webpack_public_path__ + "static/media/copy-new.1a8a8e48.svg";